export const metricLabels = { spend: 'Spend', impressions: 'Impressions', clicks: 'Clicks', conversions: 'Conversions',
  cpa: 'Cost / conversion', ctr: 'Click-through rate', cpc: 'Cost / click', cvr: 'Click conversion rate',
  roas: 'Return on ad spend', conversionValue: 'Conversion value', leads: 'Leads', cpl: 'Cost / lead', mqls: 'Marketing-qualified leads',
  sqls: 'Sales-qualified leads', opportunities: 'Opportunities', costPerSql: 'Cost / SQL', revenue: 'Revenue' };
const money = new Set(['spend', 'cpa', 'cpc', 'cpl', 'costPerSql', 'revenue', 'conversionValue']);
export function formatMetric(value, metric, currency) {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '—';
  if (money.has(metric)) {
    if (!/^[A-Z]{3}$/.test(currency || '')) return '—';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency, maximumFractionDigits: 2 }).format(value); }
    catch { return `${currency} ${value.toLocaleString(undefined, { maximumFractionDigits: 2 })}`; }
  }
  if (['ctr', 'cvr'].includes(metric)) return `${value.toLocaleString(undefined, { maximumFractionDigits: 2 })}%`;
  if (metric === 'roas') return `${value.toLocaleString(undefined, { maximumFractionDigits: 2 })}×`;
  return value.toLocaleString(undefined, { maximumFractionDigits: 2 });
}

export function formatDate(value, options = { month: 'short', day: 'numeric', year: 'numeric' }) {
  if (value == null || value === '') return 'Not available';
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return 'Not available';
  // Reporting days are calendar dates, not instants. Only timestamps convert
  // to the browser's local zone; date-only values must never shift a day.
  const dateOnly = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value);
  return new Intl.DateTimeFormat(undefined, {
    ...(!dateOnly && options.hour && !options.dateStyle && !options.timeStyle ? { timeZoneName: 'short' } : {}),
    ...options, ...(dateOnly ? { timeZone: 'UTC' } : {}),
  }).format(date);
}

export const formatTimestamp = value => formatDate(value, {
  month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short',
});

export function todayDate() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

export function presetRange(preset, today = todayDate()) {
  const date = new Date(`${today}T00:00:00Z`);
  const iso = value => value.toISOString().slice(0, 10);
  const end = new Date(date);
  if (preset === 'lastMonth') {
    date.setUTCDate(1); end.setTime(date.getTime() - 86400000);
    date.setTime(end.getTime()); date.setUTCDate(1);
  } else if (preset === 'thisMonth') date.setUTCDate(1);
  else date.setUTCDate(date.getUTCDate() - ({ last7: 6, last14: 13, last30: 29 }[preset] ?? 6));
  return { start: iso(date), end: iso(end) };
}

export function exportReport(report) {
  const blob = new Blob([JSON.stringify({ range: report.range, priorRange: report.priorRange,
    entityType: report.entityType, campaignFilters: report.campaignFilters, sourceCoverage: report.sourceCoverage, limitation: report.limitation,
    filters: report.filters, filterScope: report.filterScope, filterCoverage: report.filterCoverage, coverage: report.coverage, attributionNotice: report.attributionNotice,
    measurement: report.measurement, reportingSources: report.reportingSources, providerCoverage: report.providerCoverage,
    rows: report.rows, previous: report.previous, daily: report.daily, children: report.children,
    breakdowns: report.breakdowns, previousBreakdowns: report.previousBreakdowns }, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url; link.download = `campaign-report-${report.range.start}-${report.range.end}.json`;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
